<template>
  <!-- <div @click="opendetailrightsidebar"><i class="pi pi-bars"></i></div> -->
  <div>
    <b-Container fluid>
      <SkeletonTableLoader :columns="assetDetailsheaders" :loading="loading" />
      <!-- <div v-if="!loading" class="table-responsive">
                            <MasterEmpty v-if="assetDetailsItems.length === 0" eheader="Asset Details Items"
                                econtent="Asset Details Items" eimg="/src/assets/Img/icons/request.svg" @createNew="" />

                            <NormalTableview v-model:value="assetDetailsItems" :paginator="false"
                                class="p-datatable-gridlines " :rows="10" dataKey="id" :rowHover="true"
                                filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                                :columns="assetDetailsheaders" v-model:selection="selectedProduct" :selectionMode="true"
                                CheckDisabled="false">
                                <template v-slot:Add>

                                </template>
<template v-slot:action="{ data }">
                                    <span>
                                        <Button icon="pi pi-eye" class="p-button-rounded p-button-text"
                                            @click="viewAssetdetails(data)" />


                                    </span>
                                </template>
<template v-slot:Status="{ data }">

                                    <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                                    <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                                </template>
</NormalTableview>
</div> -->
      <!-- {{ getassetDetailsList }} -->

      <b-row class="px-3">
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.itemName") }} :
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.ItemName }}</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.serialNumber") }}
                :
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.SerialNumber }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="px-3">
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.assetType") }} :
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.CategoryName }}</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.location") }}:
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.LocationName }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="px-3">
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.assetGroup") }} :
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.GroupName }}</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.assetLifecycleStage") }}:
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">
                {{ getassetDetailsList[0]?.AssetLifecycleStage }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="px-3">
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.purchaseDate") }}:
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.PurchaseDate }}</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.purchaseCost") }}:
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.PurchaseCost }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="px-3">
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.supplierName") }}
                :
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.SupplierName }}</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.purchaseOrderNo") }}:
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">
                {{ getassetDetailsList[0]?.PurchaseOrderNumber }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="px-3">
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.barcode") }} :
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.Barcode }}</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.rfidTag") }} :
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.RFIDTag }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="">
        <b-row>
          <b-col>
            <div class="d-flex my-2">
              <img
                src="../../../../../../assets/Img/icons/downsymbol.svg"
                alt=""
                class="down-symbol"
              />
              <h6 class="bold-heading mt6 ml-1">
                {{ t("assetManagement.MassConverstion.agreements") }}
              </h6>
            </div>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="px-3" v-for="item in getassetDetailsList">
        <b-col sm="12" md="6" lg="12" xl="9">
          <b-row>
            <b-col lg="4" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.agreementname") }} :
              </p>
            </b-col>
            <b-col
              lg="5"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ item?.AgreementName }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.agreementdetails") }} :
              </p>
            </b-col>
            <b-col
              lg="5"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ item?.AgreementDetails }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- <b-row class="px-3">
                            <b-col sm="12" md="6" lg="9" xl="9">
                                <b-row>
                                    <b-col lg="4" md="6" sm="6" cols="6" class="form-field-column">
                                        <p class="light-txt">{{
                                            t('assetManagement.MassConverstion.amc') }} :
                                        </p>
                                    </b-col>
                                    <b-col lg="5" md="6" sm="6" cols="6" class="form-field-column text-start">
                                        <p class="fn14">{{ getassetDetailsList[0]?.ItemName }}</p>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row class="px-3">
                            <b-col sm="12" md="6" lg="9" xl="9">
                                <b-row>
                                    <b-col lg="4" md="6" sm="6" cols="6" class="form-field-column">
                                        <p class="light-txt">{{
                                            t('assetManagement.MassConverstion.lease') }} :
                                        </p>
                                    </b-col>
                                    <b-col lg="5" md="6" sm="6" cols="6" class="form-field-column text-start">
                                        <p class="fn14">{{ getassetDetailsList[0]?.ItemName }}</p>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row class="px-3">
                            <b-col sm="12" md="6" lg="9" xl="9">
                                <b-row>
                                    <b-col lg="4" md="6" sm="6" cols="6" class="form-field-column">
                                        <p class="light-txt">{{
                                            t('assetManagement.MassConverstion.insurance') }}
                                            :
                                        </p>
                                    </b-col>
                                    <b-col lg="5" md="6" sm="6" cols="6" class="form-field-column text-start">
                                        <p class="fn14">{{ getassetDetailsList[0]?.ItemName }}</p>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row> -->

      <b-row class="px-3">
        <b-col sm="12" md="6" lg="9" xl="9">
          <b-row>
            <b-col lg="4" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.maintenanceSchedule") }} :
              </p>
            </b-col>
            <b-col
              lg="5"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">
                {{ getassetDetailsList[0]?.MaintenanceScheduleName }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="px-3">
        <b-col sm="12" md="6" lg="9" xl="9">
          <b-row>
            <b-col lg="4" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{
                  t("assetManagement.MassConverstion.insurance1.policyNumber")
                }}
                :
              </p>
            </b-col>
            <b-col
              lg="5"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">
                {{ getassetDetailsList[0]?.PolicyNumber }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="px-3">
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.depreciationMethod") }} :
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">
                {{ getassetDetailsList[0]?.DepreciationMethodName }}
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
              <p class="light-txt">
                {{ t("assetManagement.MassConverstion.depreciationRate") }}
                :
              </p>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              cols="6"
              class="form-field-column text-start"
            >
              <p class="fn14">{{ getassetDetailsList[0]?.DepreciationRate }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-Container>
  </div>
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  onUnmounted,
  computed,
  watch,
} from "vue";
import { useI18n } from "vue-i18n";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDownfield from "../../../../../../components/FormComponents/Dropdown.vue";
import CustomDatepicker from "../../../../../../components/FormComponents/DatePicker.vue";
import NormalTableview from "../../../../../../components/FormComponents/NormalTable.vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import {
  ScanItemModel,
  AgreementList,
} from "../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/scanItemModel";
import AgreementComponents from "../../../../../../modules/Inventory/pages/AssetManagement/Transaction/components/agreementComponents.vue";
import Textarea from "../../../../../../components/FormComponents/TextArea.vue";
import AssetMasterService from "../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import moment from "moment";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";

export default defineComponent({
  props: {
    trigger: {
      type: Boolean,
      default: true,
    },
    assetDetailsList: {
      type: Object,
      required: true,
    },
    // asset: {
    //     type: Object,
    //     required: true
    // }
  },
  components: {
    Textarea,
    Footer,
    TextField,
    CustomDropDownfield,
    CustomDatepicker,
    NormalTableview,
    AgreementComponents,
  },
  setup(props, { emit }) {
    const showdetailrightsidebar = ref(false);
    const showdetails = ref(false);
    const loading = ref(false);
    const show = ref();
    const { t } = useI18n();
    const getassetDetailsList: any = ref([]);
    const sidebarwidth = computed(() => {
      return showdetails.value ? "65rem" : "35rem";
    });

    let scannedItems: any = ref([{}]);
    let assetDetailsItems: any = ref([{}]);
    let selectedProduct: any = ref([]);

    const route = useRoute();

    const data = route.query.data as string;
    const queryform = JSON.parse(data);
    // if (model.value != null) {
    //     IsEdit();
    // } else {
    //     IsCreate();
    // }
    // function opendetailrightsidebar() {
    //     showdetailrightsidebar.value = true;
    // }
    function closedetailsrightsidebar() {
      showdetailrightsidebar.value = false;
      // showdetails.value = false;
      // emit("triggerclose")
    }
    watch(
      () => props.assetDetailsList,
      (newVal: any) => {
        debugger;
        getAssetDetails();
      }
    );

    onMounted(() => {
      getAssetDetails();
    });
    async function getAssetDetails() {
      const data_response = await AssetMasterService.getByAssetIdDetails(
        props.assetDetailsList.AssetId || props.assetDetailsList.Id
      );
      console.log(data_response["result"]);
      getassetDetailsList.value = data_response["result"];
    }

    const headers = [
      {
        header: t("assetManagement.MassConverstion.serialNumber"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.MassConverstion.itemName"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.assetType"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.MassConverstion.location"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];
    const assetDetailsheaders = [
      {
        header: t("assetManagement.MassConverstion.code"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.itemName"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },

      {
        header: t("assetManagement.MassConverstion.serialNumber"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.MassConverstion.assetLifecycleStage"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.MassConverstion.department"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.MassConverstion.status"),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        slot: "Status",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    function opendetails(value) {
      showdetails.value = true;
      show.value = value;
    }
    function closedetails() {
      show.value = "";
      showdetails.value = false;
      emit("triggerclose");
    }
    let agreementType = ref();
    const isForm = ref<ScanItemModel>({
      IsNew: false,
      IsModified: false,
      IsDeleted: false,
      IsActive: false,
      CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      CreatedBy: 0,
      ModifiedBy: 0,
      ItemName: "",
      CreatedByName: "",
      ModifiedByName: "",
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      HospitalId: 0,
      BranchId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsEntitySMS: 0,
      OrganizationName: "",
      StockInId: queryform.StockTransId,
      GrnpoNumber: queryform.GrnpoNumber,
      GrnpoId: queryform.GrnpoId,
      BranchName: "",
      FromStoreBranchName: "",
      ToStoreBranchName: "",
      TaskStatus: 0,
      TaskExpiryDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      TaskName: "",
      TaskPriority: 0,
      ResponseTimeInHours: 0,
      IsApprovalRequired: false,
      LevelsOfApproval: 0,
      ModelNo: "",
      Id: 0,
      AssetDisplayId: "",
      StoreID: queryform.StoreId,
      ItemId: 0,
      CategoryId: 0,
      SubCategoryId: 0,
      AssetGroupId: 0,
      SerialNumber: "",
      AssetType: "2",
      PurchaseDate: "",
      PurchaseCost: 0,
      SupplierName: 0,
      PurchaseOrderNumber: "",
      CurrentValue: 0,
      DepreciationMethodID: 1,
      DepreciationRate: 0,
      DepreciationStartDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      MaintenanceScheduleID: 0,
      LocationID: 0,
      StatusID: 0,
      BarCode: "",
      RfidTag: "",
      AssetLifecycleStage: 0,
      UpdatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      UpdatedBy: "",
      FairMarketValue: 0.0,
      LastFMVAssessmentDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      IssueStatus: 0,
      RequestedBy: "",
      RequestId: 0,
      ToStoreId: queryform.StoreId,
      FromStoreId: queryform.StoreId,
      Type: 0,
      TrackingMechanism: 0,
      StockInDetailId: 0,
      AgreementList: <AgreementList[]>[],
    });
    const locationList = [
      { name: "Full", value: "full" },
      { name: "Partial", value: "partial" },
    ];
    let assetDetails = ref(false);
    const viewAssetdetails = (data) => {
      opendetails("second"), (assetDetails.value = true);
    };
    const parseAgreementDetails = (item) => {
      // Parse AgreementDetails from JSON string if necessary
      return JSON.parse(item.AgreementDetails || "[]");
    };
    return {
      parseAgreementDetails,
      assetDetails,
      viewAssetdetails,
      locationList,
      // agreementType,
      loading,
      isForm,
      t,
      sidebarwidth,
      showdetailrightsidebar,
      // opendetailrightsidebar,
      closedetailsrightsidebar,
      opendetails,
      closedetails,
      showdetails,
      show,
      scannedItems,
      selectedProduct,
      headers,
      assetDetailsheaders,
      assetDetailsItems,
      getassetDetailsList,
    };
  },
});
</script>

<style lang="scss" scoped>
.rightdetailssidebar {
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  transition: all 0.3s ease;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  z-index: 100;

  .sidebar-header {
    position: relative;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    padding: 15px;
    border-bottom: 1px solid #e1e1e1;
    border-right: 1px solid #e1e1e1;

    .pi-arrow-right {
      position: absolute;
      left: -15px;
      top: 60px;
      background: #e1e1e1;
      font-size: 14px;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .firstcontent {
    width: 35rem;
    flex-shrink: 0;
  }

  .secondcontent {
    width: 35rem;
    //flex-shrink: 0;
  }

  .sidebar-content {
    padding: 0px 15px 15px;
    max-height: calc(100vh - 44.8px);
    overflow: auto;
    transition: width 0.3s ease;
    flex-grow: 1;
  }
}

.form-field-column {
  margin: 8px 0px;
}

.display-field-label {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
}

.details-black-field {
  color: #444444;
  font-size: 14px;
}

.small-light-txt {
  font-size: 12px;
  color: #999999;
}
</style>
